export default {
	title: "",
	subtitle: "List Subscriptions",
  path: "subscription_list",
  paragraph: 'With this endpoint, you can retrieve a list of all your subscriptions.',
  request: {
    method: "GET",
		endpoint: "/subscriptions",
		responses: {
      "data": [
        {
          "canceled_at": null,
          "canceled_by_payer": null,
          "canceled_reason": null,
          "completed_at": null,
          "currency": "BRL",
          "cycles": 12,
          "description": "some description",
          "free_days": 0,
          "frequency": "month",
          "from_bank_account_id": null,
          "id": "187acdc6-f512-4046-8d44-704b9f353c6f",
          "inserted_at": "2025-09-19T15:02:25.261646",
          "payer_bank_account_id": null,
          "payer_card_id": "927302a6-de65-4268-aac1-2667c6ceb1c2",
          "payment_method": "card",
          "status": "active",
          "subject_id": "56c419c6-c045-4ca4-a83b-204c09336892",
          "to_bank_account_id": "7b1e792f-efec-48a8-a2b4-430b0fea286f",
          "total_retry_attempts": 0,
          "trial_days": 0,
          "updated_at": "2025-09-19T15:02:25.287880",
          "value": "100"
        },
        {
          "canceled_at": null,
          "canceled_by_payer": null,
          "canceled_reason": null,
          "completed_at": null,
          "currency": "BRL",
          "cycles": 12,
          "description": "some description",
          "free_days": 0,
          "frequency": "month",
          "from_bank_account_id": null,
          "id": "6b0c55e3-740a-4999-9407-b387be8499c2",
          "inserted_at": "2025-09-19T15:02:25.160250",
          "payer_bank_account_id": null,
          "payer_card_id": "df959a52-3611-409b-921d-472dddb67853",
          "payment_method": "card",
          "status": "active",
          "subject_id": "56c419c6-c045-4ca4-a83b-204c09336892",
          "to_bank_account_id": "7b1e792f-efec-48a8-a2b4-430b0fea286f",
          "total_retry_attempts": 0,
          "trial_days": 0,
          "updated_at": "2025-09-19T15:02:25.249591",
          "value": "100"
        }
      ]
    }
	},
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Subscription/SubscriptionList.js